/**
 * Fuzzy-match short preview labels (e.g. US_CDT_Chord_124_balanced_D#m) to Shopify Files
 * in ug-preview-files-by-handle.json (undrgrnd_pack-handle_US_…_FULL.mp3).
 */
(function (global) {
  function normalizePreviewKey(s) {
    return String(s)
      .replace(/\.(mp3|wav|m4a|mpeg)$/i, '')
      .replace(/([A-Ga-g])#m\b/g, '$1_m')
      .replace(/([A-Ga-g])#(?=[^a-z]|$)/gi, '$1_')
      .replace(/_+/g, '')
      .replace(/[^a-z0-9]/gi, '')
      .toLowerCase();
  }

  function stemFromShopifyFile(file) {
    const base = String(file).split('/').pop().replace(/\.(mp3|wav|m4a)$/i, '');
    const idx = base.search(/_(US|RR)_/i);
    if (idx >= 0) return base.slice(idx + 1);
    const m = base.match(/((?:US|RR)_.+)$/i);
    return m ? m[1] : base;
  }

  function scorePreviewMatch(wantNorm, gotNorm) {
    if (!wantNorm || !gotNorm) return 0;
    if (wantNorm === gotNorm) return 100000;
    if (gotNorm.includes(wantNorm)) {
      return wantNorm.length * 1000 - (gotNorm.length - wantNorm.length);
    }
    if (wantNorm.includes(gotNorm)) {
      return gotNorm.length * 500 - (wantNorm.length - gotNorm.length);
    }
    const minLen = Math.min(wantNorm.length, gotNorm.length);
    for (let len = minLen; len >= 12; len--) {
      for (let i = 0; i <= wantNorm.length - len; i++) {
        const sub = wantNorm.slice(i, i + len);
        if (gotNorm.includes(sub)) {
          return len * 80 - Math.abs(wantNorm.length - gotNorm.length);
        }
      }
    }
    return 0;
  }

  function flattenPreviewCatalog(manifest) {
    const out = [];
    if (!manifest || typeof manifest !== 'object') return out;
    if (Array.isArray(manifest.tracks)) {
      manifest.tracks.forEach(function (item) {
        if (item && item.url) out.push(item);
      });
      return out;
    }
    Object.keys(manifest).forEach(function (key) {
      const list = manifest[key];
      if (!Array.isArray(list)) return;
      list.forEach(function (item) {
        if (item && item.url) out.push(item);
      });
    });
    return out;
  }

  function loadPreviewManifest(url) {
    global.__ugPreviewManifestCache = global.__ugPreviewManifestCache || {};
    if (global.__ugPreviewManifestCache[url]) {
      return Promise.resolve(global.__ugPreviewManifestCache[url]);
    }
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('manifest');
        return r.json();
      })
      .then(function (json) {
        global.__ugPreviewManifestCache[url] = json;
        return json;
      });
  }

  /**
   * @param {string} label Short stem label from theme config
   * @param {{file:string,url:string}[]} catalog
   * @param {Set<string>} [usedUrls] URLs already assigned (avoid duplicates)
   * @returns {{file:string,url:string,score:number}|null}
   */
  function findBestPreviewMatch(label, catalog, usedUrls) {
    const want = normalizePreviewKey(label);
    if (!want || !catalog || !catalog.length) return null;

    let best = null;
    let bestScore = 0;

    catalog.forEach(function (item) {
      if (!item || !item.url || !item.file) return;
      if (usedUrls && usedUrls.has(item.url)) return;

      const got = normalizePreviewKey(stemFromShopifyFile(item.file));
      const score = scorePreviewMatch(want, got);
      if (score > bestScore) {
        bestScore = score;
        best = { file: item.file, url: item.url, score: score };
      }
    });

    if (!best || bestScore < 400) return null;
    return best;
  }

  function encodeFileUrl(url) {
    if (!url) return '';
    return String(url).replace(/#/g, '%23');
  }

  global.ugPreviewAudioMatch = {
    normalizePreviewKey: normalizePreviewKey,
    stemFromShopifyFile: stemFromShopifyFile,
    flattenPreviewCatalog: flattenPreviewCatalog,
    loadPreviewManifest: loadPreviewManifest,
    findBestPreviewMatch: findBestPreviewMatch,
    encodeFileUrl: encodeFileUrl
  };
})(typeof window !== 'undefined' ? window : globalThis);
